import { render, staticRenderFns } from "./DeletePortfolioModal.vue?vue&type=template&id=68517691&scoped=true"
import script from "./DeletePortfolioModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeletePortfolioModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DeletePortfolioModal.vue?vue&type=style&index=0&id=68517691&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68517691",
  null
  
)

export default component.exports